export default function getScrollableParent(element) {
    while (element) {
        const style = getComputedStyle(element);
        if (style.overflow !== 'visible' && (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth)) {
            return element;
        }
        element = element.parentElement;
    }
    return document.scrollingElement || document.documentElement;
}